import React from 'react';
import { dashboardRegistrationLink, colorBackgroundBrightness } from 'data/common.data';
import './StartNow.scss';

const StartNow = (props: any) => {
    const gotoClientLogin = () => {
        window.location.href = dashboardRegistrationLink;
    }
    const headerBg: string = '/images/backgrounds/ALEG-Image-Site-CTA_Background.jpg';
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    return (
        <>
            <div className='start-now-container container-side-padding container-content-padding' style={styleData}>
                <div className='container-small-width'>
                    <div className='container no-padding'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='text-content text-med text-l2'>
                                    Find out how you can implement your custom solutions today:
                                </div>
                                <div className='btn-wrapper'>
                                    <button className='btn-primary' onClick={gotoClientLogin}>
                                        Start Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StartNow;